import smartAuthAPI from '../smartbestbuys-api'
import { errorHandler } from '../../middleware'
import { ProductPrice } from './types'

export const getProductPrices = errorHandler<ProductPrice[]>(async (productId: number) => {
  const path = `/products/${productId}/prices`
  return await smartAuthAPI.get(path)
})
